import { Anchor, Badge, Box, Button, Center, Divider, Group, Stack, Table, Text, Textarea, TextInput, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { FormInputWrapper } from 'core/components/';
import { selectTask } from 'modules/Sessions/sessionSlice';
import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { AppConstants, DataFormats, ViewModes } from 'utils/constants';
import { getClientLabel, getCompany, pluralize } from 'utils/helper';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { updateGroupShot } from 'modules/Seasons/seasonSlice';
import { logger } from 'utils/logger';
import CustomDatePicker from 'core/components/datePicker/CustomDatePicker';

const PAGE_SIZE = 10;

const GroupShotEdit = ({ season, styles, onCancel, mode = ViewModes.EDIT, user, aggData }) => {
    const dispatch = useDispatch();
    const [isSaving, setIsSaving] = useState(false);

    // const MAX_THUMB_COUNT = 11;
    const LABEL_WIDTH = 180;
    const company = getCompany(aggData);
    const form = useForm({
        initialValues: {
            name: '',
            descr: '',
            otb_date: '',
        },

        validate:
            mode === ViewModes.ADD || mode === ViewModes.EDIT
                ? {
                      otb_date: (value) => (value && mode ? null : 'Invalid deadline'),
                      name: (value) => (value.length && mode ? null : 'Invalid name'),
                      descr: (value) => (value.length && mode ? null : 'Invalid description'),
                  }
                : {},
    });

    const onFormSubmit = (values) => {
        setIsSaving(true);
        const payload = {
            name: values.name,
            descr: values.descr,
            otb_date: values.otb_date,
            styles: styles.map((tmpStyle) => {
                return tmpStyle.stylenumber;
            }),
        };
        // const payload = styles.map((tmpStyle) => {
        //     const id = `${tmpStyle.seasonPart}__${tmpStyle.seasonSort}`;
        //     let item = {id:id,stylenumber:tmpStyle.stylenumber, styleCode:tmpStyle.stylenumber};
        //     if (values.multiShotFlag !== '-1') {
        //         item.multiShotFlag = values.multiShotFlag;
        //     }
        //     if (values.outfittingFlag !== '-1') {
        //         item.outfittingFlag = values.outfittingFlag;
        //     }
        //     if (values.channels.length > 0) {
        //         item.channels = values.channels.join(',');
        //     }
        //     if (mode === ViewModes.EDIT) {
        //         // delete item.id;
        //         //delete item.instructions;
        //     }

        //     return item;
        // });
        // logger.log(payload, 'payload');
        dispatch(updateGroupShot(payload, season));
    };

    const rows = styles.map((element, idx) => {
        return (
            <tr key={idx}>
                <td>
                    <Group sx={{ flexShrink: 0 }}>
                        <Box sx={{ flexShrink: 1 }}>
                            <Anchor size='sm'>
                                <Text size='sm' lineClamp={1} sx={{ maxWidth: '500px' }}>
                                    {element.stylenumber}
                                </Text>
                            </Anchor>
                            {/* <Text size='xs' color='dimmed'>
                                {element.id}
                            </Text> */}
                        </Box>
                    </Group>
                </td>
                <td>{element['instructions'] && element['instructions']['Name'] ? element['instructions']['Name'] : 'N/A'}</td>
                <td>{element['instructions'] && element['instructions']['departmentStr'] ? element['instructions']['departmentStr'] : 'N/A'}</td>
                {/* <td>{element.photographyCount}</td>
                {/* <td>
                    {status ? (
                        <Group noWrap>
                            <Indicator color={status.colors.primary} sx={{ zIndex: 0 }}></Indicator>
                            <Text sx={{ textTransform: 'capitalize' }}>{status.label}</Text>
                        </Group>
                    ) : null}
                </td> */}

                {/* <td><Badge variant='gradient' gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>{distSelections[0]}</Badge></td> */}
            </tr>
        );
    });

    logger.log(styles, 'styles');

    return (
        <>
            <form onSubmit={form.onSubmit((values) => onFormSubmit(values))}>
                <FormInputWrapper label='Session' labelWidth={LABEL_WIDTH}>
                    <Box>
                        <Group pb={'xs'}>
                            <Anchor component={Link} className='dark-anchor' to={`/season/${season.code}`} size={'md'}>
                                {season.name}
                            </Anchor>
                            <Badge>{season.seasonSort}</Badge>
                        </Group>
                        <Group>
                            <Text size={'sm'} color={'dimmed'}>
                                Due : {moment(season.deadline).format(DataFormats.DATE_FORMAT)}
                            </Text>
                        </Group>
                    </Box>
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper required label='Name' id='input-name' labelWidth={LABEL_WIDTH}>
                    <TextInput data-autofocus id='input-name' placeholder='Enter Name' variant={AppConstants.inputVariant} {...form.getInputProps('name')} />
                </FormInputWrapper>
                <FormInputWrapper required label='Description' id='input-name' labelWidth={LABEL_WIDTH}>
                    <Textarea id='input-descr' placeholder='Enter Description' variant={AppConstants.inputVariant} {...form.getInputProps('descr')} />
                </FormInputWrapper>
                <FormInputWrapper required label={getClientLabel(company, 'otbDate')} labelWidth={180}>
                    {/* <Input id='input-name' sx={{ width: 100 }} disabled placeholder='Enter OTB Date' variant={AppConstants.inputVariant} {...form.getInputProps('instructions.Web Stock OTB Date')} /> */}
                    <Group>
                        <CustomDatePicker sx={{ width: 200 }} placeholder='' {...form.getInputProps('otb_date')} />
                    </Group>
                </FormInputWrapper>
                <Divider my={'lg'} />
                {/* <FormInputWrapper label='Agency' id='input-agency'>
                    <Input disabled={!enabled} id='input-agency' placeholder='Enter Agency' variant={AppConstants.inputVariant} {...form.getInputProps('agency')} />
                </FormInputWrapper> */}

                {/* <FormInputWrapper label='Age' id='input-age'>
                    <Input sx={{ width: 200 }} disabled={!enabled} id='input-age' placeholder='Enter Age' variant={AppConstants.inputVariant} {...form.getInputProps('age')} />
                </FormInputWrapper> */}
                {/* <FormInputWrapper label='Muti Shot' labelWidth={LABEL_WIDTH} description='Multi Shot includes both Talent and Flatlay shot'>
                    
                    <SegmentedControl
                        sx={{ width: '100%' }}
                        data={[
                            { label: 'Single Shot', value: '' },
                            { label: 'Multi Shot', value: 'Y' },
                        ]}
                        // placeholder='PSD Loaded'
                        {...form.getInputProps('multiShotFlag')}
                    />
                </FormInputWrapper> */}

                {/* <Divider my={'lg'} />
                <FormInputWrapper label='Outfitting Available' labelWidth={LABEL_WIDTH} description='Are the correct styles available for styling?'>
                    <SegmentedControl
                        sx={{ width: '100%' }}
                        data={[
                            { label: 'Yes', value: 'Y' },
                            { label: 'No', value: '' },
                        ]}
                        // placeholder='PSD Loaded'
                        {...form.getInputProps('outfittingFlag')}
                    />
                </FormInputWrapper>
                <Divider my={'lg'} />
                <FormInputWrapper label='Channels' labelWidth={LABEL_WIDTH} id='input-channels' description='Select the channels for the event styles'>
                    <Stack spacing='xs' mt={4}>
                        {shotChannels.map((channel, index) => (
                            <Checkbox
                                key={index}
                                label={channel.label}
                                value={channel.value}
                                checked={form.values.channels?.includes(channel.value) || false}
                                onChange={(event) => {
                                    const currentChannels = form.values.channels || [];
                                    if (event.currentTarget.checked) {
                                        form.setFieldValue('channels', [...currentChannels, channel.value]);
                                    } else {
                                        form.setFieldValue(
                                            'channels',
                                            currentChannels.filter((c) => c !== channel.value),
                                        );
                                    }
                                }}
                            />
                        ))}
                    </Stack>
                </FormInputWrapper>
                <Divider my={'lg'} /> */}
                <Stack>
                    <Group>
                        <Title mb={0} align='left' order={5}>
                            Styles to be included in the group shot:
                        </Title>
                        <Group align={'center'} position='center'>
                            <Badge variant='gradient' gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }} size='md'>
                                {styles.length} {pluralize('Style', styles.length)}
                            </Badge>
                        </Group>
                    </Group>
                    <Center>
                        <Table withBorder sx={{ maxWidth: '100%' }}>
                            <thead>
                                <tr>
                                    <th>Style</th>
                                    <th>Name</th>
                                    <th>Department</th>
                                    {/* <th>Captures</th> */}
                                    {/* <th>Session</th>
                                    <th>Style</th> */}
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </Table>
                    </Center>
                </Stack>

                {/* <Box my={'lg'}>
                    <Title order={5}>Uploads</Title>
                    {previews}
                </Box> */}

                <Group position='apart' mt='lg'>
                    <Button variant='default' onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button type='submit' disabled={!form.isValid() || !form.isDirty()} loading={isSaving}>
                        {mode === ViewModes.ADD ? 'Create Group Shot' : 'Update Group Shot'}
                    </Button>
                </Group>
                {/* </FocusTrap> */}
            </form>
        </>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        success: state.seasonReducer.success,
        error: state.seasonReducer.error,
        aggData: state.appReducer.aggData,
    };
};

const mapDispatch = { selectTask };

export default connect(mapStateToProps, mapDispatch)(GroupShotEdit);

// const SelectItem = forwardRef(({ label, color, ...others }, ref) => {
//     const isUnassigned = label.toLowerCase() === 'unassign' ? true : false;

//     return (
//         <div ref={ref} {...others}>
//             <Group noWrap>
//                 <Avatar variant='filled' title={`${label}`} color={isUnassigned ? 'gray' : color} size={30} radius={40}>
//                     {isUnassigned ? <IconUser style={{ opacity: 0.5 }} /> : label.charAt(0)}
//                 </Avatar>
//                 <Text sx={{ paddingLeft: 0 }}>{label}</Text>
//             </Group>
//         </div>
//     );
// });
